<template>
  <div>
  <v-card-text class="text-xs-center">{{title}}</v-card-text>
  <v-card-text>{{content}}</v-card-text>
  </div>
</template>

<script>
export default {
  name: 'privacy',
  data () {
    return {
      title: '개인정보 처리방침',
      content: '프로토 배당분석 (이하 "서비스")은 개인정보를 수집하고 있지 않습니다.'
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/accessTerms/privacy.vue